var _rect, _text, _rect2, _circle, _text2, _text3, _text4, _path, _rect3, _circle2, _text5, _text6, _text7, _path2, _rect4, _circle3, _text8, _text9, _text0, _path3, _rect5, _circle4, _text1, _text10, _text11, _path4, _rect6, _circle5, _text12, _text13, _text14, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentDeliveryProcessPathwayMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 700,
    viewBox: "0 0 360 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Custom system delivery pathway") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 358,
    height: 698,
    rx: 27,
    fill: "#020B1B",
    stroke: "#2B5A85"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 39,
    fill: "#74BDFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 24,
    dy: 0
  }, "DELIVERY PATHWAY"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 65,
    width: 312,
    height: 102,
    rx: 17,
    fill: "#0A1C34",
    stroke: "#294766"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 92,
    r: 13,
    fill: "#74BDFF",
    fillOpacity: 0.14,
    stroke: "#74BDFF"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 96,
    textAnchor: "middle",
    fill: "#74BDFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850
  }, "01")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 96,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "Discover")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 41,
    y: 127,
    fill: "#AFC0D6",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 41,
    dy: 0
  }, "Problem, users, process and data."))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 167v20",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 188,
    width: 312,
    height: 102,
    rx: 17,
    fill: "#0A1C34",
    stroke: "#294766"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 215,
    r: 13,
    fill: "#FF2775",
    fillOpacity: 0.14,
    stroke: "#FF2775"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 219,
    textAnchor: "middle",
    fill: "#FF2775",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850
  }, "02")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 219,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "Design")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 41,
    y: 250,
    fill: "#AFC0D6",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 41,
    dy: 0
  }, "Architecture, controls and experience."))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180 290v20",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 311,
    width: 312,
    height: 102,
    rx: 17,
    fill: "#0A1C34",
    stroke: "#294766"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 338,
    r: 13,
    fill: "#F4B63D",
    fillOpacity: 0.14,
    stroke: "#F4B63D"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 342,
    textAnchor: "middle",
    fill: "#F4B63D",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850
  }, "03")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 342,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "Prototype")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 41,
    y: 373,
    fill: "#AFC0D6",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 41,
    dy: 0
  }, "Validate the workflow before full build."))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180 413v20",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 434,
    width: 312,
    height: 102,
    rx: 17,
    fill: "#0A1C34",
    stroke: "#294766"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 461,
    r: 13,
    fill: "#30D6A1",
    fillOpacity: 0.14,
    stroke: "#30D6A1"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 465,
    textAnchor: "middle",
    fill: "#30D6A1",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850
  }, "04")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 465,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "Build and integrate")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 41,
    y: 496,
    fill: "#AFC0D6",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 41,
    dy: 0
  }, "Engineer, test and connect the system."))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180 536v20",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 557,
    width: 312,
    height: 102,
    rx: 17,
    fill: "#0A1C34",
    stroke: "#294766"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 584,
    r: 13,
    fill: "#087CFF",
    fillOpacity: 0.14,
    stroke: "#087CFF"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 588,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850
  }, "05")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 588,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "Deploy and optimise")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 41,
    y: 619,
    fill: "#AFC0D6",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 41,
    dy: 0
  }, "Adoption, measurement and refinement."))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 669,
    width: 312,
    height: 16,
    rx: 8,
    fill: "#10243E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 669,
    width: 286,
    height: 16,
    rx: 8,
    fill: "#087CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentDeliveryProcessPathwayMobile);
export default __webpack_public_path__ + "static/media/custom-development-delivery-process-pathway-mobile.85215b1f35829d0761c1c8eba2384941.svg";
export { ForwardRef as ReactComponent };